export const ExternalSearch = 'ExternalSearch';
export const ExternalSearchInTransit = 'ExternalSearchInTransit';
export const ExternalSearchDelivered = 'ExternalSearchDelivered';
export const ExternalSearchBooked = 'ExternalSearchBooked';
export const ExternalSearchAwaitingDispatch = 'ExternalSearchAwaitingDispatch';
